import { CheckboxGroup } from "@/base/index";
import { useCheckboxGroupListStyles } from "./checkbox-group-list.styles";
import { cx } from "antd-style";
import { CheckboxGroupListProps } from "../types/index";

export const CheckboxGroupListCheckboxGroup = ({
  value: propValue,
  onChange,
  className,
  maxLength = 1,
  ...props
}: Pick<
  CheckboxGroupListProps,
  "options" | "disabled" | "value" | "onChange" | "maxLength"
> & {
  className?: string;
}) => {
  const { styles } = useCheckboxGroupListStyles();

  const handleChange = (changeValues: unknown[]) => {
    const stringValues = changeValues as string[];
    if (maxLength === 1) {
      const values = stringValues?.filter(
        (value: string) => !propValue?.includes(value),
      );
      onChange?.(values);
    } else if (maxLength >= stringValues.length) {
      onChange?.(stringValues);
    }
  };

  return (
    <CheckboxGroup
      {...props}
      value={propValue}
      onChange={handleChange}
      className={cx(styles.checkboxGroup, className)}
    />
  );
};
